var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0203 18.7795C11.0203 18.7795 2.42651 13.967 2.42651 8.1233C2.42651 7.09023 2.78444 6.08907 3.43939 5.29016C4.09434 4.49125 5.00586 3.94393 6.01887 3.74133C7.03187 3.53873 8.08379 3.69336 8.99563 4.17891C9.90748 4.66447 10.6229 5.45095 11.0203 6.40455V6.40455C11.4176 5.45095 12.133 4.66447 13.0449 4.17891C13.9567 3.69336 15.0087 3.53873 16.0217 3.74133C17.0347 3.94393 17.9462 4.49125 18.6011 5.29016C19.2561 6.08907 19.614 7.09023 19.614 8.1233C19.614 13.967 11.0203 18.7795 11.0203 18.7795Z",
    stroke: "currentColor",
    strokeWidth: 1.38209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.48c2f7bfe16eb3dbb8eee13126a5f0a1.svg";
export { ForwardRef as ReactComponent };